import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import config from 'config';
import ButtonLoader from 'LIBRARY/CommonResources/ButtonLoader/ButtonLoader';
import RoutingMenu from 'LIBRARY/CommonResources/RoutingMenu/RoutingMenu';
import "LIBRARY/Components/User/UserIssuedResources/userIssuedResorces.css";
import LibraryApiCall from 'LibraryApiCall';
import { Component } from 'react';
import ReactHtmlParser from 'react-html-parser';
import Pagination from 'react-js-pagination';
import { connect } from 'react-redux';
import ReactToPrint from 'react-to-print';
import ReactHTMLTableToExcel from 'react-html-table-to-excel';
import "LIBRARY/Components/User/UserRequisition/StudentRequisition.css"
import Select from 'react-select';
import SuccessModal from 'LIBRARY/CommonResources/SuccessModal/SuccessModal';
import DeleteModal from 'LIBRARY/CommonResources/DeleteModal/DeleteModal';
import { toast } from 'react-toastify';

let categorySubCategoryData = [];

class StudentRequisition extends Component {

    constructor(props) {
        super(props);
        this.state = {
            offset: 0,
            pageIndex: 1,
            limit: 10,
            accessDataList: false,
            successModal: false,

            //VARIABLE TO GET REQUISITION DATA LIST
            requisitionLoading: false,
            requisitionData: {},
            totalRequisitionItem: 0,
            sortedIdArray: [],

            linkedInstituteArray: {},
            linkedIidArray: [],

            addRequisition: false,
            editRequisition: false,
            GetResourceCategoryList: {},
            loadingResourceCategoryData: false,

            academicYearSequence: [],
            academicYearList: [],

            GetStreamList: {},
            loadingStreamData: false,

            requisitionTitle: "",
            requisitionAuthor: "",
            requisitionRequestedQuantity: 1,
            requisitionPublisher: "",
            requisitionAcademicYear: "",
            requisitionCategory: "",
            requisitionRemark: "",
            requisitionDepartment: "",
            selectedRequisitionUniqueId: "",

            // field validation
            requisitionTitleWarning: '',
            requisitionRequestedQuantityWarning: '',
            requisitionAcademicYearWarning: '',
            requisitionDepartmentWarning: '',

            // VARIABLES TO DELETE SINGLE RESOURCES
            deleteSingleResources: false,
            deletingResources: false,

            //STATE FOR header
            exportCSVHeaders: [
                { name: "Title", key: 'title' },
                { name: "Author", key: 'author' },
                { name: "Required Quantity", key: 'requiredQuantity' },
                { name: "Publisher", key: 'publisher' },
                { name: "Academic year", key: 'academicYear' },
                { name: "Resource Category", key: 'resourceCategory' },
                { name: "Department", key: 'department' },
                { name: "Requested On", key: 'requestedOn' },
                { name: "Remark by Librarian", key: 'remark' },
                { name: "Status", key: 'status' }
            ],

            dataHideWhileExporting: true,
        }
    }

    componentDidMount() {
        // this.GetAssignedInstituteList();
        this.getRequisitionList();
        this.GetLibraryResourceCategoryListWithBasicDetails();  // resource category
        this.apiCallToGetAcademicYearList();
        this.apiCallToGetInstituteStreamList();  // department

        this.formatCSVExportData('onLoad'); // export data
    }

    //FUNCTION DEFINED TO INITIATE THE EXPORT DOWNLOAD PROCESS FOR DEPARTMENT LIST
    exportCSVData = () => {
        document.getElementById('export').click();
        this.setState({ dataHideWhileExporting: true })
    }

    // FUNCTION TO FORMAT DATA BEFORE EXPORTING
    formatCSVExportData = (action) => {
        let exportSelectedCSVHeaders = this.state.exportCSVHeaders;

        exportSelectedCSVHeaders = [{ label: "Sr.No.", key: "srNo" },];

        this.state.exportCSVHeaders.map(csvInfo => {
            exportSelectedCSVHeaders.push(csvInfo);
        });

        this.setState({
            exportSelectedCSVHeaders
        }, () => {
            if (action != 'onLoad') {
                this.exportCSVData();
            }
        });
    }

    //API CALL METHOD TO GET Institute
    GetAssignedInstituteList = async () => {
        let requestData = {
            "iid": config.institute_id,
        };

        let jsonResponse = await LibraryApiCall.makeApiCall(
            'library_GetLinkedInstituteStatus',
            requestData,
            '/api/library/libraryLinkInstitute.php'
        );

        if (jsonResponse.expired) {
            setTimeout(() => {
                this.GetAssignedInstituteList();
            }, 1000);
        } else {
            if (jsonResponse.success) {
                let apiResult = jsonResponse.APIResult;

                let linkedInstituteData = apiResult.linkedInstituteData;
                let linkedIidArrayValue = apiResult.linkedIidArray;

                this.setState({
                    linkedInstituteArray: linkedInstituteData,
                    linkedIidArray: linkedIidArrayValue
                });

                this.getRequisitionList()
            } else {
                this.setState({
                    successModal: true,
                    successModalType: 'error',
                    successMessage: 'Something went wrong while getting list. Please try again later.'
                });
            }
        }
    }

    //API CALL METHOD TO LIST OF DONOR LIST REPORT
    getRequisitionList = async () => {
        this.setState({
            requisitionLoading: true
        });

        let requestData = {
            'iid': config.institute_id,
            'pageIndex': this.state.pageIndex,
            'limitPerPage': this.state.limit,
            'RequesterId': config.studentId,
            'RequesterRole': "learner",
        };

        let jsonResponse = await LibraryApiCall.makeApiCall(
            'getRequisitionList',
            requestData,
            '/api/library/instructor.php'
        );

        if (jsonResponse.expired) {
            setTimeout(() => {
                this.getRequisitionList()
            }, 1000);
        } else {
            if (jsonResponse.success) {
                let apiResult = jsonResponse.APIResult;

                if (apiResult?.data) {
                    if (apiResult.success == 'true') {
                        this.setState({
                            requisitionData: apiResult.data,
                            totalRequisitionItem: apiResult.totalRecords,
                            sortedIdArray: apiResult.sortedIdArray,
                            requisitionLoading: false
                        });
                    } else {
                        this.setState({
                            requisitionData: {},
                            totalRequisitionItem: 0,
                            sortedIdArray: [],
                            requisitionLoading: false
                        });
                    }
                } else {
                    this.setState({
                        successModal: true,
                        successModalType: 'warning',
                        successMessage: apiResult.message,
                    });

                    this.setState({
                        requisitionData: {},
                        sortedIdArray: [],
                        requisitionLoading: false
                    });
                }
            }
        }
    }

    // API CALL TO GET get resource category List 
    GetLibraryResourceCategoryListWithBasicDetails = async () => {
        this.setState({
            loadingResourceCategoryData: true,
        })

        let requestData = {
            iid: config.institute_id,
            isSortByAscendingCategoryName: "true"
        }

        let jsonResponse = await LibraryApiCall.makeApiCall(
            'GetLibraryResourceCategoryListWithBasicDetails',
            requestData,
            "/api/library/instructor.php"
        );

        if (jsonResponse.expired) {
            setTimeout(() => {
                this.GetLibraryResourceCategoryListWithBasicDetails();
            }, 1000);
        } else {

            if (jsonResponse.success) {
                let apiResult = jsonResponse.APIResult;

                const formattedData = Object.entries(apiResult.data).map(([seriesId, seriesData]) => {
                    // Initialize an empty array to hold sublocations
                    const subCategories = [];

                    // If there are subCategories, iterate through them
                    if (Object.values(seriesData.subresource).length > 0) {
                        Object.entries(seriesData.subresource).forEach(([subCategoryId, subCategoryData]) => {
                            subCategories.push({
                                subCategoryId: subCategoryId,
                                subCategoryName: subCategoryData.name,
                                parentId: subCategoryData.parentCategoryId
                            });
                        });
                    }

                    // Return the formatted data
                    return {
                        value: seriesId,
                        name: seriesData?.name, // Display name
                        uniqueId: seriesId,
                        subCategories: subCategories // Add subresource data (if any)
                    };
                });


                this.setState({
                    GetResourceCategoryList: formattedData,
                    loadingResourceCategoryData: false,
                })
            } else {
                this.setState({
                    loadingResourceCategoryData: false,
                })
            }
        }
    }

    // METHOD TO GET ACADEMIC YEAR LIST
    apiCallToGetAcademicYearList = async () => {
        let requestData = {
            "iid": config.institute_id,
        };

        let jsonResponse = await LibraryApiCall.makeApiCall(
            'GetAcademicYearListObject',
            requestData,
            '/api/admission/streamManagement.php'
        );

        if (jsonResponse.expired) {
            setTimeout(() => {
                this.apiCallToGetAcademicYearList();
            }, 1000);
        } else {
            if (jsonResponse.success) {
                let apiResult = jsonResponse.APIResult.data;

                // Map the apiData to the desired format
                const formattedData = Object.keys(apiResult).map(key => ({
                    yearID: key,
                    yearName: apiResult[key].year_text
                }));

                this.setState({
                    academicYearArray: formattedData,
                    academicYearList: apiResult,
                    academicYearSequence: jsonResponse.APIResult.sortedIdArray,
                });
            } else {
                this.setState({
                    successModal: true,
                    successModalType: 'error',
                    successMessage: 'Something went wrong while getting academic year list. Please try again later.'
                });
            }
        }
    }

    // API CALL TO GET get Institute Stream List 
    apiCallToGetInstituteStreamList = async () => {
        this.setState({
            loadingStreamData: true,
        })

        let requestData = {
            "iid": config.institute_id
        }

        let jsonResponse = await LibraryApiCall.makeApiCall(
            'getInstituteStreamList',
            requestData,
            "/api/instructor/facultyRegistration.php"
        );

        if (jsonResponse.expired) {
            setTimeout(() => {
                this.apiCallToGetInstituteStreamList();
            }, 1000);
        } else {

            if (jsonResponse.success) {
                let apiResult = jsonResponse.APIResult;

                this.setState({
                    GetStreamList: apiResult.streamData,
                    loadingStreamData: false,
                })
            } else {
                this.setState({
                    loadingStreamData: false,
                })
            }
        }
    }

    // on change for per page change
    updatePaginationCount = (pageNumber) => {
        this.setState({ pageIndex: pageNumber }, () => {
            this.getRequisitionList();
        });
    };

    // on change for show entries per page
    changeShowEntriesControl = (event) => {
        this.setState({ pageIndex: 1, limit: event.target.value }, () => {
            this.getRequisitionList();
        });
    }

    // METHOD TO CLOSE SUCCESS MODAL
    closeSuccessModal = () => {
        this.setState({
            successModal: false
        });
    }

    stripHtml = (html) => {
        const doc = new DOMParser().parseFromString(html, 'text/html');
        return doc.body.textContent || "";
    }

    // Add Edit Requisition API Call
    validateRequisitionSubmission = async () => {
        let validData = true;
        let jsonResponse = {};

        // requisitionTitle
        if (!this.state.requisitionTitle) {
            this.setState({
                requisitionTitleWarning: 'Please enter resource title.'
            });
            validData = false;
        } else if (this.state.requisitionTitle.length < 3) {
            this.setState({
                requisitionTitleWarning: 'Minimum 3 characters are required.'
            });
            validData = false;
        } else if (this.state.requisitionTitle.length > 100) {
            this.setState({
                requisitionTitleWarning: 'Maximum 100 characters are allowed.'
            });
            validData = false;
        } else {
            this.setState({
                requisitionTitleWarning: ''
            });
        }

        // requisitionAuthor
        if (this.state.requisitionAuthor && this.state.requisitionAuthor.length > 200) {
            this.setState({
                requisitionAuthorWarning: 'Maximum 200 characters are allowed.'
            });
            validData = false;
        } else {
            this.setState({
                requisitionAuthorWarning: ''
            });
        }

        // requisitionPublisher
        if (this.state.requisitionPublisher && this.state.requisitionPublisher.length > 100) {
            this.setState({
                requisitionPublisherWarning: 'Maximum 100 characters are allowed.'
            });
            validData = false;
        } else {
            this.setState({
                requisitionPublisherWarning: ''
            });
        }

        // requisitionRemark
        if (this.state.requisitionRemark && this.state.requisitionRemark.length > 500) {
            this.setState({
                requisitionRemarkWarning: 'Maximum 500 characters are allowed.'
            });
            validData = false;
        } else {
            this.setState({
                requisitionRemarkWarning: ''
            });
        }

        if (!this.state.requisitionAcademicYear) {
            this.setState({
                requisitionAcademicYearWarning: 'Please select academic year.'
            });
            validData = false;
        }

        if (!this.state.requisitionRequestedQuantity) {
            this.setState({
                requisitionRequestedQuantityWarning: 'Please enter requested quantity.'
            });
            validData = false;
        }

        if (!this.state.requisitionDepartment || this.state.requisitionDepartment?.length == 0) {
            this.setState({
                requisitionDepartmentWarning: 'Please select department.'
            });
            validData = false;
        }

        // Check if it's a positive integer
        if (!/^[1-9]\d*$/.test(this.state.requisitionRequestedQuantity)) {
            this.setState({
                requisitionRequestedQuantityWarning: 'Please enter a valid positive integer number.',
            });
            validData = false;
        }

        if (validData) {

            let RequisitionDetails = {
                "title": this.state.requisitionTitle,
                "author": this.state.requisitionAuthor,
                "quantity": this.state.requisitionRequestedQuantity,
                "publisher": this.state.requisitionPublisher,
                "remark": this.state.requisitionRemark,
                "year": this.state.requisitionAcademicYear,
                "stream": this.state.requisitionDepartment?.map(item => item.value),
                "resourceCategory": this.state.requisitionCategory ? this.state.requisitionCategory?.map(item => item.value) : "",
                "resourceCategoryName": this.state.requisitionCategory ? this.state.requisitionCategory?.map(item => item.label).join(",") : "",
                "requesterRole": "learner"
            }

            this.setState({
                addRequisitionLoading: true
            });


            let requestDataAdd = {
                "iid": config.institute_id,
                "RequisitionDetails": RequisitionDetails,
                "facultyId": config.studentId,
            }

            let requestDataUpdate = {
                "iid": config.institute_id,
                "RequisitionDetails": RequisitionDetails,
                "facultyId": config.studentId,
                "uniqueId": this.state.selectedRequisitionUniqueId
            }

            this.state.editRequisition ?
                jsonResponse = await LibraryApiCall.makeApiCall(
                    'UpdateLibraryRequisition',
                    requestDataUpdate,
                    "/api/library/instructor.php"
                ) :
                jsonResponse = await LibraryApiCall.makeApiCall(
                    'AddLibraryRequisition',
                    requestDataAdd,
                    "/api/library/instructor.php"
                )

            if (jsonResponse.expired) {
                setTimeout(() => {
                    this.validateRequisitionSubmission()
                }, 1000);
            } else {
                if (jsonResponse.success) {
                    let apiResult = jsonResponse.APIResult;

                    if (apiResult.status == 'success') {
                        this.setState({
                            successModal: true,
                            successModalType: 'success',
                            successMessage: this.stripHtml(apiResult.message),
                            addRequisitionLoading: false
                        });
                        this.closeAddRequisition()
                        this.getRequisitionList();
                    } else {
                        this.setState({
                            successModal: true,
                            successModalType: 'warning',
                            successMessage: this.stripHtml(apiResult.message),
                            addRequisitionLoading: false
                        });
                    }
                } else {
                    this.setState({
                        successModal: true,
                        successModalType: 'error',
                        successMessage: 'Something went wrong. Please try again later.',
                        addRequisitionLoading: false
                    });
                }
            }
        }
    }

    // Method to open add modal
    addOrEditRequisitionModal = () => {
        this.setState({
            addRequisition: true,
        })
    }

    // Method to close add or edit modal
    closeAddRequisition = () => {
        this.setState({
            addRequisition: false,
            editRequisition: false,
            requisitionTitle: "",
            requisitionAuthor: "",
            requisitionRequestedQuantity: 1,
            requisitionPublisher: "",
            requisitionAcademicYear: "",
            requisitionCategory: "",
            requisitionRemark: "",
            requisitionDepartment: "",
            selectedRequisitionUniqueId: ""
        })
    }

    // METHOD TO EDIT
    editRequisitionDetails = (requisition, requisitionUID) => {
        const selectedDepartments = requisition.stream
            ?.replace(/'/g, "")      // remove single quotes
            .split(",")              // split into array
            .map((sid) => {
                // Map to objects that React-Select expects
                const dept = Object.values(this.state.GetStreamList).find(
                    (d) => String(d.sid) === sid.trim()
                );
                return dept ? { value: dept.sid, label: dept.name } : null;
            })
            .filter(Boolean); // remove nulls if some sid not found

        // Prepare flattened category + subcategory options
        const categorySubCategoryData = Object.values(this.state.GetResourceCategoryList).flatMap(item => {
            const categoryOption = {
                value: item.value,
                label: item.name,
                isDisabled: item.subCategories.length > 0,
            };

            const subCategoryOptions = item.subCategories.map(subCategory => ({
                value: subCategory.subCategoryId,
                label: subCategory.subCategoryName,
                isDisabled: false,
            }));

            return [categoryOption, ...subCategoryOptions];
        });

        // Pre-fill Categories (resourceCategory)
        const selectedCategories = requisition.resourceCategory
            ?.replace(/'/g, "") // remove single quotes
            .split(",")
            .map((cid) => {
                const cat = categorySubCategoryData.find(
                    (c) => String(c.value) === cid.trim()
                );
                return cat ? { value: cat.value, label: cat.label } : null;
            })
            .filter(Boolean);

        this.setState({
            addRequisition: true,
            editRequisition: true,
            requisitionTitle: requisition?.title,
            requisitionAuthor: requisition?.author,
            requisitionRequestedQuantity: requisition?.quantity || 1,
            requisitionPublisher: requisition?.publisher,
            requisitionAcademicYear: requisition.year,
            requisitionCategory: selectedCategories,
            requisitionRemark: requisition?.approver_remark,
            requisitionDepartment: selectedDepartments,
            selectedRequisitionUniqueId: requisitionUID
        });
    }

    // METHOD TO RETURN ADD requisition
    returnAddRequisition = () => {
        // custom category and sub-category data list
        categorySubCategoryData = Object.values(this.state.GetResourceCategoryList).flatMap(item => {
            // Start with the category itself
            const categoryOption = {
                value: item.value,
                label: item.name,
                isDisabled: item.subCategories.length > 0, // Disable the category if it has subcategories
            };

            // If the category has subcategories, add those as well
            const subCategoryOptions = item.subCategories.map(subCategory => ({
                value: subCategory.subCategoryId,
                // label: `${item.name} => ${subCategory.subCategoryName}`, // Parent category name followed by subcategory name
                label: subCategory.subCategoryName, // Parent category name followed by subcategory name
                isDisabled: false, // Subcategory is always enabled
            }));

            // Return the category option followed by the subcategory options
            return [categoryOption, ...subCategoryOptions];
        });
        return (
            <div id="addAccessSideMenu" style={{ display: this.state.addRequisition ? 'flex' : 'none' }}>
                <div id="addResourceDataContainer">
                    {/* header */}
                    <div id="addAccessHeader" className="row">
                        <FontAwesomeIcon icon={['fas', 'times']} size="lg" color="#000" onClick={() => this.closeAddRequisition()} style={{ cursor: "pointer" }} />
                        <h5 style={{ paddingLeft: '40%' }} className="col-11">{this.state.editRequisition ? "Edit Resource Requisition" : "Add Resource Requisition"}</h5>
                    </div>

                    {/* content */}
                    <div className='col-md-12 pl-4 pt-2'>
                        <div className='d-flex pb-3'>
                            <div className='col-md-6 pl-0'>
                                <label className='fs-14 fieldHeadColor '>Title <span className='text-danger'>*</span></label>
                                <div className="input-group input-group-field" style={{ position: 'relative' }}>
                                    <input
                                        type="text"
                                        className="form-control formControlAutoTask"
                                        id="searchByTitleFilter"
                                        placeholder="Enter Title"
                                        style={{ height: '42px', color: '#808080', zIndex: 0, borderRadius: '5px', width: '200px', fontSize: "13px" }}
                                        value={this.state.requisitionTitle} // Bind value to state
                                        onChange={(event) => {
                                            this.setState({
                                                requisitionTitle: event.target.value || '', // Handle empty selection
                                                requisitionTitleWarning: ""
                                            });
                                        }}
                                        maxLength={100}
                                        minLength={3}
                                    />
                                </div>
                                <p className="d-flex justify-content-start" style={{ color: '#7A7A7A', fontSize: '12px' }}>(Minimum 3 and maximum 100 characters are allowed)</p>
                                <p style={{ display: this.state.requisitionTitleWarning.length > 0 ? 'block' : 'none', color: 'red', fontSize: 12 }}>{this.state.requisitionTitleWarning}</p>
                            </div>
                            <div className='col-md-6 pl-0'>
                                <label className='fs-14 fieldHeadColor '>Author</label>
                                <div className="input-group input-group-field" style={{ position: 'relative' }}>
                                    <input
                                        type="text"
                                        className="form-control formControlAutoTask"
                                        id="searchByTitleFilter"
                                        placeholder="Enter Author"
                                        style={{ height: '42px', color: '#808080', zIndex: 0, borderRadius: '5px', width: '200px', fontSize: "13px" }}
                                        value={this.state.requisitionAuthor} // Bind value to state
                                        onChange={(event) => {
                                            this.setState({
                                                requisitionAuthor: event.target.value || '', // Handle empty selection
                                            });
                                        }}
                                        maxLength={200}
                                    />
                                </div>
                                <p className="d-flex justify-content-start" style={{ color: '#7A7A7A', fontSize: '12px' }}>(For multiple, use comma(,) to separate.Maximum 200 characters are allowed)</p>
                            </div>
                        </div>
                    </div>
                    <div className='col-md-12 pl-4 pt-2'>
                        <div className='d-flex pb-3'>
                            <div className='col-md-6 pl-0'>
                                <label className='fs-14 fieldHeadColor '>Requested Quantity <span className='text-danger'>*</span></label>
                                <div className="input-group input-group-field" style={{ position: 'relative' }}>
                                    <input
                                        type="number"
                                        className="form-control formControlAutoTask"
                                        id="searchByTitleFilter"
                                        placeholder="Enter Requested Quantity"
                                        style={{
                                            height: '42px',
                                            color: '#808080',
                                            zIndex: 0,
                                            borderRadius: '5px',
                                            width: '200px',
                                            fontSize: "13px"
                                        }}
                                        value={this.state.requisitionRequestedQuantity} // Bind value to state
                                        onChange={(event) => {
                                            // Only allow positive integers
                                            const value = event.target.value;
                                            if (/^\d*$/.test(value)) { // only digits
                                                this.setState({
                                                    requisitionRequestedQuantity: value ? parseInt(value, 10) : '',
                                                    requisitionRequestedQuantityWarning: ""
                                                });
                                            }
                                        }}
                                        min={1}
                                    />
                                </div>
                                <p style={{ display: this.state.requisitionRequestedQuantityWarning.length > 0 ? 'block' : 'none', color: 'red', fontSize: 12 }}>{this.state.requisitionRequestedQuantityWarning}</p>
                            </div>
                            <div className='col-md-6 pl-0'>
                                <label className='fs-14 fieldHeadColor '>Publisher</label>
                                <div className="input-group input-group-field" style={{ position: 'relative' }}>
                                    <input
                                        type="text"
                                        className="form-control formControlAutoTask"
                                        id="searchByTitleFilter"
                                        placeholder="Enter Publisher"
                                        style={{ height: '42px', color: '#808080', zIndex: 0, borderRadius: '5px', width: '200px', fontSize: "13px" }}
                                        value={this.state.requisitionPublisher} // Bind value to state
                                        onChange={(event) => {
                                            this.setState({
                                                requisitionPublisher: event.target.value || '', // Handle empty selection
                                            });
                                        }}
                                        maxLength={100}
                                    />
                                </div>
                                <p className="d-flex justify-content-start" style={{ color: '#7A7A7A', fontSize: '12px' }}>(Maximum 100 characters are allowed)</p>
                            </div>
                        </div>
                    </div>
                    <div className='col-md-12 pl-4 pt-2'>
                        <div className='d-flex pb-3'>
                            <div className='col-md-6 pl-0'>
                                <label className='fs-14 fieldHeadColor '>Academic year <span className='text-danger'>*</span></label>
                                <div className="input-group input-group-field" style={{ position: 'relative' }}>
                                    <Select
                                        name="AcademicYearFilter"
                                        placeholder="Select Academic Year"
                                        options={
                                            Object.keys(this.state.academicYearList).length > 0
                                                ? this.state.academicYearSequence.map((yearId) => {
                                                    const year = this.state.academicYearList[yearId];
                                                    return {
                                                        value: yearId,
                                                        label: year.year_text,
                                                    };
                                                })
                                                : []
                                        }
                                        value={
                                            this.state.requisitionAcademicYear
                                                ? {
                                                    value: this.state.requisitionAcademicYear,
                                                    label:
                                                        this.state.academicYearList[this.state.requisitionAcademicYear]?.year_text ||
                                                        "",
                                                }
                                                : null
                                        }
                                        onChange={(selectedOption) => {
                                            this.setState({
                                                requisitionAcademicYear: selectedOption ? selectedOption.value : "",
                                                requisitionAcademicYearWarning: ""
                                            });
                                        }}
                                        styles={{
                                            control: (base) => ({
                                                ...base,
                                                minHeight: 42,
                                                fontSize: "13px",
                                                fontWeight: 400,
                                                borderRadius: "7px",
                                                borderColor: "#ccc",
                                                boxShadow: "none",
                                                "&:hover": { borderColor: "#999" },
                                            }),
                                            menu: (base) => ({
                                                ...base,
                                                zIndex: 9999,
                                            }),
                                            menuPortal: (base) => ({
                                                ...base,
                                                zIndex: 9999,
                                            }),
                                            option: (base, state) => ({
                                                ...base,
                                                fontSize: "13px",
                                                fontWeight: 400,
                                                backgroundColor: state.isFocused ? "#f0f0f0" : "white",
                                                color: state.isSelected ? "#333" : "#555",
                                            }),
                                            placeholder: (base) => ({
                                                ...base,
                                                color: "#808080",
                                            }),
                                            singleValue: (base) => ({
                                                ...base,
                                                color: "#333",
                                            }),
                                        }}
                                        menuPortalTarget={document.body}
                                    />
                                </div>
                                <p style={{ display: this.state.requisitionAcademicYearWarning.length > 0 ? 'block' : 'none', color: 'red', fontSize: 12 }}>{this.state.requisitionAcademicYearWarning}</p>
                            </div>
                            <div className='col-md-6 pl-0'>
                                <label className='fs-14 fieldHeadColor '>Resource Category</label>
                                <div className="input-group input-group-field" style={{ position: 'relative' }}>
                                    <Select
                                        isMulti
                                        options={categorySubCategoryData}
                                        value={this.state.requisitionCategory}
                                        className="basic-multi-select-filter"
                                        onChange={(event) => {
                                            this.setState({
                                                requisitionCategory: event || [], // Handle empty selection
                                                resourceCategoryWarning: ''
                                            });
                                        }}
                                        placeholder="Select Resource Category"
                                        isLoading={this.state.loadingResourceCategoryData} // Show loading spinner while fetching
                                        styles={{
                                            control: (base) => ({
                                                ...base,
                                                width: '100%',
                                                minHeight: 42, // Minimum height for the control area
                                                height: 'auto', // Allow control to grow dynamically
                                            }),
                                            multiValue: (base) => ({
                                                ...base,
                                                backgroundColor: 'none',
                                                borderRadius: '5px',
                                                border: '1px solid #c4c5c5',
                                                fontSize: '12px',
                                                fontWeight: '400',
                                                color: '#808080',
                                                display: 'inline-flex',
                                                margin: '2px',
                                                whiteSpace: 'nowrap',
                                            }),
                                            multiValueContainer: (base) => ({
                                                ...base,
                                                display: 'flex',
                                                flexWrap: 'wrap',
                                                overflowX: 'auto', // Horizontal scroll when values overflow
                                                minHeight: 42, // Ensure consistent height when values are selected
                                            }),
                                            menu: (base) => ({
                                                ...base,
                                                zIndex: 9999, // Ensure the dropdown appears above other elements
                                            }),
                                            menuPortal: (base) => ({
                                                ...base,
                                                zIndex: 9999, // Make sure the dropdown portal also respects the z-index
                                            }),
                                            placeholder: (base) => ({
                                                ...base,
                                                fontSize: '12px',
                                                fontWeight: '400',
                                            }),
                                            option: (base, state) => ({
                                                ...base,
                                                fontSize: '12px',
                                                fontWeight: '400',
                                                backgroundColor: state.isDisabled ? '#f0f0f0' : state.isFocused ? '#e0e0e0' : 'white',
                                                color: state.isDisabled ? '#999' : '#555',
                                                cursor: state.isDisabled ? 'not-allowed' : 'default',
                                            }),
                                        }}
                                        menuPortalTarget={document.body}
                                        noOptionsMessage={() => (this.state.loadingResourceCategoryData ? "Loading..." : "No options found")}
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className='col-md-12 pl-4 pt-2'>
                        <div className='d-flex pb-3'>
                            <div className='col-md-6 pl-0'>
                                <label className='fs-14 fieldHeadColor '>Remark</label>
                                <div className="input-group input-group-field" style={{ position: 'relative' }}>
                                    <textarea
                                        className={`form-control`}
                                        rows="5"
                                        maxLength={250}
                                        placeholder="Enter Message content here"
                                        value={this.state.requisitionRemark}
                                        onChange={(event) => {
                                            this.setState({
                                                requisitionRemark: event.target.value || '',
                                            });
                                        }}
                                    />
                                </div>
                                <p className="d-flex justify-content-start" style={{ color: '#7A7A7A', fontSize: '12px' }}>(Maximum 500 characters are allowed)</p>
                            </div>
                            <div className='col-md-6 pl-0'>
                                <label className='fs-14 fieldHeadColor '>Department <span className='text-danger'>*</span></label>
                                <div className="input-group input-group-field" style={{ position: 'relative' }}>
                                    <Select
                                        isMulti
                                        options={Object.values(this.state.GetStreamList).map(item => ({
                                            value: item.sid,
                                            label: item.name,
                                        }))}
                                        value={this.state.requisitionDepartment}
                                        className="basic-multi-select-filter"
                                        onChange={(event) => {
                                            this.setState({
                                                requisitionDepartment: event || [], // Handle empty selection
                                                requisitionDepartmentWarning: ""
                                            });
                                        }}
                                        placeholder="Select Department"
                                        isLoading={this.state.loadingStreamData} // Show loading spinner while fetching
                                        styles={{
                                            control: (base) => ({
                                                ...base,
                                                width: '100%',
                                                minHeight: 42, // Minimum height for the control area
                                                height: 'auto', // Allow control to grow dynamically
                                            }),
                                            multiValue: (base) => ({
                                                ...base,
                                                backgroundColor: 'none',
                                                borderRadius: '5px',
                                                border: '1px solid #c4c5c5',
                                                fontSize: '12px',
                                                fontWeight: '400',
                                                color: '#808080',
                                                display: 'inline-flex',
                                                margin: '2px',
                                                whiteSpace: 'nowrap',
                                            }),
                                            multiValueContainer: (base) => ({
                                                ...base,
                                                display: 'flex',
                                                flexWrap: 'wrap',
                                                overflowX: 'auto', // Horizontal scroll when values overflow
                                                minHeight: 42, // Ensure consistent height when values are selected
                                            }),
                                            menu: (base) => ({
                                                ...base,
                                                zIndex: 9999, // Ensure the dropdown appears above other elements
                                            }),
                                            menuPortal: (base) => ({
                                                ...base,
                                                zIndex: 9999, // Make sure the dropdown portal also respects the z-index
                                            }),
                                            placeholder: (base) => ({
                                                ...base,
                                                fontSize: '12px',
                                                fontWeight: '400',
                                            }),
                                            option: (base, state) => ({
                                                ...base,
                                                fontSize: '12px',
                                                fontWeight: '400',
                                                backgroundColor: state.isFocused ? '#f0f0f0' : 'white',
                                                color: state.isSelected ? '#333' : '#555',
                                            }),
                                        }}
                                        menuPortalTarget={document.body}
                                        noOptionsMessage={() => (this.state.loadingStreamData ? "Loading..." : "No options found")}
                                    />
                                </div>
                                <p style={{ display: this.state.requisitionDepartmentWarning.length > 0 ? 'block' : 'none', color: 'red', fontSize: 12 }}>{this.state.requisitionDepartmentWarning}</p>
                            </div>
                        </div>
                    </div>

                    {/* footer */}
                    <div className="modal-footer pt-5">
                        {this.state.addRequisitionLoading ? <ButtonLoader /> : null}
                        <button className="btn btn-outline-primary waves-effect" onClick={() => this.closeAddRequisition()}>Cancel</button>
                        <button className="btn btn-primary" onClick={() => this.validateRequisitionSubmission()} disabled={this.state.addRequisitionLoading}>{this.state.editRequisition ? "Update Resource Requisition" : "Add Resource Requisition"}</button>
                    </div>
                </div>
            </div>
        );
    }


    // METHOD TO CLOSE DELETE MODAL
    closeDeleteResources = () => {
        this.setState({
            deleteResources: false,
            deletingResources: false,
            deleteSingleResources: false,
        });
    }

    // DELETE Single Resource
    deleteSingleResourceModal = (resourceData) => {
        this.setState({
            deleteSingleResources: true, singleResourceData: resourceData
        });
    }

    // API CALL METHOD TO DELETE Single Resource
    apiCallToDeleteSingleResource = async () => {
        this.setState({
            deletingResources: true
        });

        let requestData = {
            'iid': config.institute_id,
            'facultyId': config.studentId,
            'unique_id': this.state.singleResourceData,
        };

        let jsonResponse = await LibraryApiCall.makeApiCall(
            'DeleteLibraryRequisition',
            requestData,
            '/api/library/instructor.php'
        );

        if (jsonResponse.expired) {
            setTimeout(() => {
                this.apiCallToDeleteSingleResource();
            }, 1000);
        } else {
            let apiResult = jsonResponse.APIResult || {};
            let message = this.stripHtml(apiResult.message || jsonResponse.message || "");

            if (apiResult.status === 'success') {
                this.closeDeleteResources();

                toast.success(message, {
                    position: "top-right",
                    autoClose: 2000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                });

                this.setState({
                    singleResourceData: {},
                    deletingResources: false,
                });

                this.getRequisitionList();

            } else {
                this.setState({ deletingResources: false });
                toast.warn(message || "Something went wrong", {
                    position: "top-right",
                    autoClose: 2000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                });
            }

        }
    }

    render() {
        return (
            <>
                <RoutingMenu activeScreen="UserRequisition" />

                <div className="libraryComponents-container pr-3">
                    <div className="pb-4">
                        <div className="d-flex justify-content-between align-items-center pt-1 pb-2">
                            {/* Left Side - Heading */}
                            <h4 className="mb-0">Resource Requisition</h4>

                            {/* Right Side - Buttons */}
                            <div className="d-flex gap-2">
                                {/* Click to Print */}
                                <div title="Click to Print">
                                    <span className="print-button">
                                        <ReactToPrint
                                            trigger={() => {
                                                return (
                                                    <div className="print-button btn outline-button ml-2" style={{ borderRadius: '5px', boxShadow: 'none !important' }}>
                                                        <style type="text/css" media="print">
                                                            {"@page { size: auto; }"}
                                                        </style>
                                                        <span>
                                                            <FontAwesomeIcon icon={['fas', 'print']} size='lg' title="Click to Print" style={{ cursor: "pointer", color: '#0465AC' }} />
                                                        </span>
                                                    </div>
                                                )
                                            }}
                                            content={() => this.componentRef}
                                        />
                                    </span>
                                </div>
                                {/* Click to Export */}
                                <div className="d-flex ml-2" title="Click to Export" >
                                    <button className="btn outline-button" id='exportDropdownMenu' data-toggle="dropdown" aria-expanded="false" data-bs-toggle="dropdown" aria-haspopup="true" style={{ borderRadius: '5px', boxShadow: 'none' }}> <style type="text/css" media="print">
                                        {"@page { size: auto; }"}
                                    </style><FontAwesomeIcon size='lg' icon={["fa", "file-export"]} style={{ cursor: "pointer", color: '#0465AC' }} /></button>

                                    {/* 2.1 action button option - export*/}
                                    <div className="dropdown-menu" aria-labelledby='exportDropdownMenu'>
                                        <span>
                                            <div style={{ display: 'none' }}>
                                                <ReactHTMLTableToExcel
                                                    id="export"
                                                    className="btn outline-button waves-effect text-capitalize"
                                                    table="resourceList"
                                                    filename="RequisitionList"
                                                    sheet="tablexls"
                                                    buttonText="Export to Excel "
                                                >
                                                </ReactHTMLTableToExcel>
                                            </div>
                                            <button
                                                onClick={() => {
                                                    this.setState({ dataHideWhileExporting: false }, () => {
                                                        this.formatCSVExportData()
                                                    })
                                                }}
                                                className="dropdown-item"
                                                title="Click to Export"
                                                style={{ boxShadow: 'none' }}
                                            >
                                                Export
                                            </button>
                                        </span>

                                    </div>

                                </div>
                                {/* Add button */}
                                <button
                                    type="button"
                                    onClick={() => this.addOrEditRequisitionModal()}
                                    className="btn btn-primary br-5"
                                    style={{ fontSize: "13px" }}
                                >
                                    <FontAwesomeIcon size="sm" icon={["fa", "plus"]} /> &nbsp;
                                    Add Requisition
                                </button>
                            </div>
                        </div>
                    </div>


                    {/* list table */}
                    <div className="col-md-12 px-0 div_table">
                        <div className="table-responsive fixTableHead table_pad" id='tableResponsive'>
                            <div className="print-area" ref={el => this.componentRef = el}>
                                <div className="buildingReport_logo">
                                    <img className="report-college-logo" alt="college-logo" src={config.instructorInfo.InstituteLogo} />
                                    <p className="report-college-name">{ReactHtmlParser(config.instructorInfo.InstituteName)}</p>
                                    <h3>Resource Requisition</h3>
                                </div>
                                <table className="table table-bordered  vm_libraryReport_table" id="resourceList">
                                    <thead>
                                        {/* Hidden rows for titles, etc. */}
                                        <tr className='d-none'>
                                            <th colSpan="14" style={{ textAlign: 'center' }}>{config.institute_name}</th>
                                        </tr>
                                        <tr className='d-none'>
                                            <th colSpan="14" style={{ textAlign: 'center' }}>Resource Requisition</th>
                                        </tr>
                                        <tr className='d-none'>
                                            <th colSpan="14" ></th>
                                        </tr>
                                        <tr>
                                            <tr className='d-none'>
                                                <th colSpan="11"></th>
                                            </tr>
                                            <th>Sr.No.</th>
                                            <th>Title</th>
                                            <th>Author</th>
                                            <th>Required Quantity</th>
                                            <th>Publisher</th>
                                            <th>Academic year</th>
                                            <th>Resource Category</th>
                                            <th>Department</th>
                                            <th>Requested On</th>
                                            <th>Remark by Librarian</th>
                                            <th>Status</th>
                                            {this.state.dataHideWhileExporting && <th className="printHide">Action</th>}
                                        </tr>
                                    </thead>

                                    <tbody>
                                        {
                                            this.state.requisitionLoading ?
                                                <tr>
                                                    <td colSpan="7">
                                                        <ButtonLoader />
                                                    </td>
                                                </tr> :
                                                this.state.sortedIdArray?.length > 0 ? (
                                                    this.state.sortedIdArray.map((requisitionUID, index) => {
                                                        const requisitionItem = this.state.requisitionData[requisitionUID];
                                                        if (!requisitionItem) return null; // Skip if missing

                                                        return (
                                                            <tr key={index}>
                                                                <td>{
                                                                    this.state.limit === 'all' ? index + 1 :
                                                                        ((this.state.pageIndex - 1) * this.state.limit) + index + 1
                                                                }</td>
                                                                <td>{requisitionItem?.title || ""}</td>
                                                                <td>{requisitionItem?.author || ""}</td>
                                                                <td>{requisitionItem?.quantity || ""}</td>
                                                                <td>{requisitionItem?.publisher || ""}</td>
                                                                <td>{this.state.academicYearList[requisitionItem.year]?.year_text || ""}</td>
                                                                <td>{requisitionItem?.resourceCategoryName || ""}</td>
                                                                <td>{requisitionItem?.streamname || ""}</td>
                                                                <td>{requisitionItem?.requested_on || ""}</td>
                                                                <td>{requisitionItem?.approver_remark || ""}</td>
                                                                <td>{requisitionItem?.status || ""}</td>
                                                                {this.state.dataHideWhileExporting &&
                                                                    <td className="printHide" >
                                                                        <FontAwesomeIcon icon={['far', 'edit']} size="lg" title="Click to edit resource" style={{ cursor: "pointer", marginRight: 5 }} onClick={() => this.editRequisitionDetails(requisitionItem, requisitionUID)} />
                                                                        <FontAwesomeIcon icon={['far', 'trash-alt']} size="lg" title="Click to delete requisitionItem" style={{ cursor: "pointer", marginRight: 5 }} onClick={() => this.deleteSingleResourceModal(requisitionUID)} />
                                                                    </td>
                                                                }
                                                            </tr>
                                                        )
                                                    })) :
                                                    <tr>
                                                        <td colSpan="11">
                                                            No data found.
                                                        </td>
                                                    </tr>
                                        }
                                    </tbody>
                                </table>
                            </div>
                        </div>
                        {
                            (Object.keys(this.state.requisitionData).length > 0 || Object.keys(this.state.requisitionData).length > this.state.limit) &&
                            <div className='row px-0'>
                                <div className='col-md-12 px-0' style={{ background: "#f5f8fa", borderRadius: "4px" }}>
                                    <div className='row align-items-center justify-content-between'>
                                        <div className='col-lg-4 col-md-12 col-12 pl-0 hidePrint'>
                                            <div className='d-flex justify-content-lg-start justify-content-sm-center justify-content-center '>
                                                <span className="d-flex align-items-center" style={{ fontSize: 14, marginLeft: 4 }}>
                                                    <select className="mx-2 p-1 vm_select_border" name="pageSize" id="" value={this.state.limit} onChange={this.changeShowEntriesControl}>
                                                        <option value={10}>Entries Per Page 10</option>
                                                        <option value={25}>Entries Per Page 25</option>
                                                        <option value={40}>Entries Per Page 40</option>
                                                        <option value={100}>Entries Per Page 100</option>
                                                        <option value={250}>Entries Per Page 250</option>
                                                    </select>
                                                </span>
                                            </div>
                                        </div>
                                        <div className='col-lg-4 col-md-12 col-12 justify-content-center'>
                                            <div id="paginationContainer" className="hidePrint" style={{ margin: "12px auto" }}>
                                                <Pagination
                                                    activePage={this.state.pageIndex}
                                                    itemsCountPerPage={this.state.limit}
                                                    totalItemsCount={this.state.totalRequisitionItem}
                                                    pageRangeDisplayed={3}
                                                    onChange={this.updatePaginationCount}
                                                />
                                            </div>
                                        </div>
                                        <div className='col-lg-4 col-md-12 col-12 pr-0 hidePrint'>
                                            <span className="d-flex justify-content-end align-items-center " style={{ fontSize: 14, marginRight: "21px" }}>
                                                Total Records : {this.state.totalRequisitionItem || 0}
                                            </span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        }
                    </div>

                    {
                        this.returnAddRequisition()
                    }
                    {
                        this.state.successModal &&
                        <SuccessModal
                            successModal={this.state.successModal}
                            successModalType={this.state.successModalType}
                            successMessage={this.state.successMessage}
                            closeSuccessModal={this.closeSuccessModal}
                        />
                    }
                    {/* modal for single resource delete */}
                    {
                        this.state.deleteSingleResources &&
                        <DeleteModal
                            showModal={this.state.deleteSingleResources}
                            visibility={this.closeDeleteResources}
                            deleteKey='Requisition'
                            deleteComponent={this.apiCallToDeleteSingleResource}
                            buttonDisable={this.state.deletingResources}
                        />
                    }
                </div>
            </>
        )
    }

}
const mapStateToProps = store => {
    return {
        // VARIABLES TO GET AGENCY DETAILS
        accessibleOperations: store.RouteMenuReducer.accessibleOperations,
        isAdmin: store.RouteMenuReducer.isLibraryAdmin,
        iidArray: { ...store.RouteMenuReducer.iidArray }
    };
};

export default connect(mapStateToProps)(StudentRequisition);